import { CartLinesUpdateEvent } from '@shopify/events';

if (!customElements.get('rh-cross-sell')) {
  customElements.define('rh-cross-sell', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('submit', event => this.addItem(event));
    }
    async addItem(event) {
      event.preventDefault();
      const form = event.target;
      const button = form.querySelector('button');
      if (button.disabled || !form.reportValidity()) return;
      const status = form.querySelector('.rh-cross-sell__status');
      const id = Number(new FormData(form).get('id'));
      button.disabled = true;
      status.textContent = 'Adding…';
      const deferred = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add', context: 'cart', lines: [{merchandiseId: String(id), quantity: 1}],
        promise: deferred.promise
      }));
      try {
        const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
          .map(element => element.dataset.sectionId).filter(Boolean))];
        const response = await fetch(`${this.dataset.root}cart/add.js`, {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: [{id, quantity: 1}], sections, sections_url: location.pathname})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This item could not be added. Please check the available sizes.');
        const cartResponse = await fetch(`${this.dataset.root}cart.js`);
        if (!cartResponse.ok) throw new Error('Your item was added. Refresh your cart to see the updated total.');
        const cart = await cartResponse.json();
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {items: cart.items, sections: result.sections, source: 'rangeheart-cross-sell',
            productId: this.dataset.productId, itemCount: 1, didError: false}
        });
        status.textContent = 'Added to your cart.';
      } catch (error) {
        deferred.reject(error);
        status.textContent = error instanceof TypeError
          ? 'Could not confirm the update. Check your cart before trying again.' : error.message;
        button.disabled = false;
      }
    }
  });
}
